import { Component, Input, OnInit } from '@angular/core';
import { ContainerService } from '../../shared/services/container/container.service';
import {
    Container,
    ContainerJoinRequestList,
    ContainerType,
} from '../../shared/models/container.types';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import {
    ContainerSettingsDialogData,
    SettingsComponent,
} from '../../shared/components/container-administration/container-settings/settings.component';
import {
    ContainerMembersComponent,
    ContainerMembersDialogData,
} from '../../shared/components/container-administration/container-members/container-members.component';
import { ContainerWizardComponent } from 'src/app/project/component/container-wizard/container-wizard.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-img-db-header',
    templateUrl: './img-db-header.component.html',
    styleUrls: ['./img-db-header.component.scss'],
    standalone: false,
})
export class ImgDbHeaderComponent implements OnInit {
    @Input() isUserOwner: boolean;
    @Input() container: Container;

    joinRequests: ContainerJoinRequestList;

    hoveredFunctionalButtonIdx: number = -1;

    constructor(
        private dialog: MatDialog,
        private containerService: ContainerService,
        private modal: NgbModal
    ) {}

    ngOnInit(): void {
        if (this.isUserOwner) {
            this.containerService
                .getOpenJoinRequestsForContainer(this.container.id)
                .subscribe((requests: ContainerJoinRequestList) => {
                    this.joinRequests = requests;
                });
        }
    }

    areRequestsExisting() {
        return this.joinRequests?.values?.length > 0;
    }

    openSettings() {
        const dialogConfig = new MatDialogConfig<ContainerSettingsDialogData>();
        dialogConfig.autoFocus = false;
        dialogConfig.data = { container: this.container };

        this.dialog
            .open(SettingsComponent, dialogConfig)
            .afterClosed()
            .subscribe();
    }

    openMembers() {
        const dialogConfig = new MatDialogConfig<ContainerMembersDialogData>();
        dialogConfig.autoFocus = false;
        dialogConfig.data = {
            joinRequests: this.joinRequests,
            container: this.container,
        };

        this.dialog
            .open(ContainerMembersComponent, dialogConfig)
            .afterClosed()
            .subscribe();
    }

    onOpenCreationWizard() {
        let modalRef = this.modal.open(ContainerWizardComponent, {
            size: 'lg',
            modalDialogClass: 'add-project-wizard-modal',
        });
        modalRef.componentInstance.type = ContainerType.PROJECT_VISUAL;
        modalRef.componentInstance.config = {
            slideIndex: 1,
            creationData: { parameter: this.container.imageDb?.id },
        };
    }
}
